module.exports = __webpack_public_path__ + "img/spieleoase.df7c7ec3.png";